import { ButtonLink } from '@sleepstation/components'
import { BreakingLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import {
  backgroundImageLinearGradient,
  paddingV,
  stylesIfPropTrue,
} from '@sleepstation/style-api-helpers'
import { classStartsWith, constrainWide } from '@sleepstation/style-mixins'
import { SleepstationPortalMarkSvg } from '@sleepstation/svgs-sleepstation-branding'
import { defaultTheme, reversedTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styled, { ThemeProvider, css } from 'styled-components'
import PageNavDropdownMenu from '../../../shared/PageNavDropdownMenu'
import LogoLink from '../shared/LogoLink'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const LABEL = `Menu`

const LABEL_SELECTED = `Close`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const AccountNavWrapper = styled.div`
  ${classStartsWith(`Icon__`)} {
    position: relative;
    top: 1px;
  }
`

const Wrapper = styled.div`
  position: relative;
  ${backgroundImageLinearGradient()}

  ${stylesIfPropTrue(
    `hideBackground`,
    css`
      background: transparent;
    `
  )}
`

const Layout = styled.div`
  position: relative;

  /* Ensure header is in front of body */
  z-index: 99 !important;

  > * {
    ${paddingV([0.5, 0.75])}
    flex: 0 0 auto;
  }
`

const Inner = styled(BreakingLayout).attrs({
  spacing: LAYOUT_SPACING.BETWEEN,
  align: LAYOUT_ALIGN.CENTER,
})`
  ${constrainWide()}
`

const Background = styled.div`
  opacity: 0;
  visibility: hidden;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  transition:
    visibility 0.5s,
    opacity 0.5s ease-in;
  background: black;
  cursor: pointer;

  ${stylesIfPropTrue(
    `isSelected`,
    css`
      opacity: 0.6;
      visibility: visible;
      transition:
        visibility 0s,
        opacity 0.5s ease-out;
    `
  )}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SiteHeaderPortal = ({ hideNav, hideBackground, navItems, homeUrl }) => {
  const [isSelected, setIsSelected] = useState(false)

  return (
    <ThemeProvider theme={reversedTheme}>
      <Wrapper hideBackground={hideBackground}>
        <ThemeProvider theme={defaultTheme}>
          <Background
            isSelected={isSelected}
            onClick={() => setIsSelected(false)}
          />
        </ThemeProvider>
        <PageNavDropdownMenu
          links={navItems}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
        />
        <Layout as="header">
          <Inner>
            <LogoLink logoSvg={SleepstationPortalMarkSvg} to={homeUrl} />
            {!hideNav && (
              <AccountNavWrapper>
                <ButtonLink
                  icon="openMenu"
                  iconSelected="closeMenu"
                  data-cy="account-nav-open-link"
                  iconIsLast
                  label={LABEL}
                  isSelected={isSelected}
                  labelSelected={LABEL_SELECTED}
                  onClick={() => setIsSelected(!isSelected)}
                />
              </AccountNavWrapper>
            )}
          </Inner>
        </Layout>
      </Wrapper>
    </ThemeProvider>
  )
}

SiteHeaderPortal.propTypes = {
  hideBackground: PropTypes.bool,
  navItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  homeUrl: PropTypes.string.isRequired,
  hideNav: PropTypes.bool,
}

SiteHeaderPortal.defaultProps = {
  hideBackground: false,
  hideNav: false,
}

export default SiteHeaderPortal
